/**
 * Die interne Audio-Referenz einer Sprachnachricht.
 *
 * Der Sprachweg haengt an den Text jeder Aufnahme eine Zeile
 * `[Audio: /uploads/ptt-<zeit>-<id>.webm]`. Sie ist fuer die Wiedergabe da —
 * fuer den Leser und fuer jede Auswertung des Gesagten ist sie Rauschen.
 *
 * ⚠️ 20.09.2026 GEMESSEN, warum das eine eigene Datei rechtfertigt:
 *    Die Marke ist IMMER gleich lang: 49 Zeichen, mit der Leerzeile davor
 *    51 (min = median = max ueber 219 Nachrichten). 219 von 345 Nachrichten
 *    einer Woche tragen sie — 63 %. Jede Regel, die an der LAENGE eines
 *    Satzes haengt, rechnet bei diesen 63 % also 51 Zeichen URL mit.
 *
 *    In `absicht.ts` hiess das konkret: eine „schnelle Frage" (<= 90 Zeichen)
 *    durfte per Sprache nur 39 Zeichen Rede haben, eine „lange Erzaehlung"
 *    (> 220) begann schon bei 169. Sechs Auftraege bekamen dadurch den
 *    Hinweis „nimm dir Zeit, jemand denkt laut" — darunter „raeumt die
 *    Tickets zusammen und stosse Cloud Code an".
 *
 * ⚠️ Das Abstreifen stand an SECHS Stellen in zwei Sprachen des Projekts
 *    (frontend/app.ts dreimal, frontend/lib/markdown.ts, und serverseitig
 *    GAR NICHT). Erzeugt wird sie in server/voice-command.ts.
 */

/** Woran die Marke erkannt wird — sie steht immer am Ende des Textes. */
const AUDIO_MARKE_ANFANG = "[Audio: /uploads/";

/** Die Marke, wie der Sprachweg sie anhaengt. */
export function audioMarke(audioUrl: string): string {
  return `[Audio: ${audioUrl}]`;
}

/**
 * Der Text mit den Marken seiner Tondateien — eine je Zeile, am Ende, in
 * der Reihenfolge der Aufnahme. Mit einer Datei genau das, was der
 * Sprachweg immer anhing; ohne bleibt der Text, wie er ist.
 *
 * Ticket 2618 (29.09.2026): Ein langes Diktat in Teilen hat mehrere
 * Tondateien — jede bleibt an der Nachricht. Wer die Marke abschneidet
 * (`ohneAudioMarke`), schneidet ab der ersten, also alle.
 */
export function mitAudioMarken(text: string, urls: readonly (string | null | undefined)[]): string {
  const marken = urls.filter((u): u is string => typeof u === "string" && u !== "").map(audioMarke);
  return marken.length > 0 ? `${text}\n\n${marken.join("\n")}` : text;
}

/**
 * Der Text ohne die Marke.
 *
 * Schneidet ab der Marke ab, nicht per Suchen-und-Ersetzen: Alles dahinter
 * gehoert zur Referenz, nicht zum Gesagten.
 */
export function ohneAudioMarke(text: string): string {
  const t = text ?? "";
  const i = t.indexOf(AUDIO_MARKE_ANFANG);
  return (i >= 0 ? t.slice(0, i) : t).trim();
}
